<template>
  <v-form v-model="form_valid">
    <v-container fill-height>
      <v-layout align-center justify-center fill-height id="my-profile">
        <v-flex xs12 class="text-center py-5 my-5" v-if="loading">
          <v-progress-circular indeterminate color="primary" :size="50"></v-progress-circular>
        </v-flex>

        <v-flex v-else>
          <v-container class="mb-8">
            <v-row v-if="!is_fullfilled">
              <v-col cols="12" md="6" offset-md="3">
                <v-alert
                  :value="!is_fullfilled"
                  :dismissible="false"
                  type="info"
                  color="seconary"
                  outlined
                  class="ma-0"
                >{{ trans('user.profile_incomplete_message') }}</v-alert>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <v-card>
                  <v-card-title class="mb-3">{{ trans('user.profile_contacts') }}</v-card-title>
                  <v-card-text>
                    <v-text-field
                      v-model="email"
                      :rules="rules.email"
                      :data-label="trans('user.email')"
                      :error="hasError('email')"
                      :error-messages="getError('email')"
                      @input="unsetError('email')"
                      outlined
                    >
                      <template v-slot:label>
                        <span>{{ trans('user.email') }}</span>
                        <span v-if="!email" class="error--text">*</span>
                        <v-icon color="success" v-if="email_verified">mdi-check</v-icon>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="phone_number"
                      :rules="rules.phone_number"
                      :error="hasError('phone_number')"
                      :error-messages="getError('phone_number')"
                      @input="unsetError('phone_number')"
                      outlined
                    >
                      <template v-slot:label>
                        <span>{{ trans('user.phone_number') }}</span>
                        <span v-if="!phone_number" class="error--text">*</span>
                        <v-icon v-if="phone_number_verified">mdi-check-circle</v-icon>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="first_name"
                      :rules="rules.first_name"
                      :error="hasError('first_name')"
                      :error-messages="getError('first_name')"
                      @input="unsetError('first_name')"
                      outlined
                    >
                      <template v-slot:label>
                        <span>{{ trans('user.first_name') }}</span>
                        <span v-if="!first_name" class="error--text">*</span>
                      </template>
                    </v-text-field>

                    <v-text-field
                      v-model="last_name"
                      :label="trans('user.last_name')"
                      :error="hasError('last_name')"
                      :error-messages="getError('last_name')"
                      @input="unsetError('last_name')"
                      outlined
                    ></v-text-field>

                    <v-col cols="12" v-if="providers" class="pt-0">
                      <div class="mb-1 caption">{{ trans('user.auth_providers') }}</div>
                      <v-row class="px-2">
                        <template v-for="provider,i in providers">
                          <v-icon
                            class="mr-3"
                            v-if="provider.providerId == 'facebook.com'"
                            :key="i"
                          >mdi-facebook-box</v-icon>
                          <v-icon
                            class="mr-3"
                            v-else-if="provider.providerId == 'google.com'"
                            :key="i"
                          >mdi-google</v-icon>
                          <v-icon
                            class="mr-3"
                            v-else-if="provider.providerId == 'phone'"
                            :key="i"
                          >mdi-phone</v-icon>
                          <v-icon
                            class="mr-3"
                            v-else-if="provider.providerId == 'password'"
                            :key="i"
                          >mdi-email</v-icon>
                        </template>
                      </v-row>
                    </v-col>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" md="6" offset-md="3">
                <v-card>
                  <v-card-title class="mb-3">{{ trans('user.profile_privacy') }}</v-card-title>
                  <v-card-text>
                    <v-checkbox
                      :false-value="false"
                      :true-value="true"
                      v-model="email_visible"
                      :label="trans('user.email_visible')"
                    ></v-checkbox>

                    <v-checkbox
                      :false-value="false"
                      :true-value="true"
                      v-model="phone_number_visible"
                      :label="trans('user.phone_number_visible')"
                    ></v-checkbox>

                    <v-checkbox
                      :false-value="false"
                      :true-value="true"
                      v-model="last_name_visible"
                      :label="trans('user.last_name_visible')"
                    ></v-checkbox>
                  </v-card-text>
                </v-card>
                <div class="text-right">
                  <v-btn
                    :dark="can_save"
                    :color="saved ? 'success' : 'primary'"
                    :loading="saving"
                    :disabled="!can_save"
                    class="ml-auto mt-2"
                    rounded
                    @click="save"
                  >Save</v-btn>
                </div>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <!--
							<v-row>
					        <v-col cols="auto" class="ml-auto">
							<v-btn :dark="is_fullfilled" color="primary" :loading="saving" :disabled="!is_fullfilled" @click="save">
								<span>{{ trans('user.save_profile') }}</span>
					        </v-btn>
					    	</v-col>
					    	</v-row>
                -->
              </v-col>
            </v-row>
          </v-container>
        </v-flex>
      </v-layout>

      <v-snackbar color="success" v-model="saved">
        <span>{{ trans('user.profile_was_saved') }}</span>
        <v-btn dark text @click="saved = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-container>
  </v-form>
</template>

<script>
import { auth } from "../firebase";
import _ from "lodash";
import { mapGetters, mapActions, mapState } from "vuex";

let regex_email = new RegExp(
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
let regex_phone = new RegExp(
  /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/i
);

export default {
  data: () => ({
    phone_mask: "+############",
    // role	admin
    // locale	en
    // email	andrewdevelop@gmail.com
    // phone_number	null
    // first_name	null
    // last_name	null
    // email_visible	0
    // phone_number_visible	0
    // last_name_visible	0
    // email_verified	0
    // phone_number_verified	0
    // provider	password
    // locked_at	null
    // deleted_at	null
    // filled	false
    // activity	null
    buffer: {},
    saved: false,
    is_dirty: false,
    form_valid: false,

    regex_email: regex_email,
    regex_phone: regex_phone,

    firebase_user: null
  }),

  computed: {
    ...mapState("user", {
      store_instance: "instance"
    }),
    ...mapGetters("user", {
      isLoading: "isLoading"
    }),
    ...mapGetters("errors", {
      getError: "get",
      hasError: "has"
    }),

    loading: function() {
      return this.isLoading("load");
    },
    saving: function() {
      return this.isLoading("store");
    },

    instance: {
      get: function() {
        if (this.store_instance) {
          this.buffer = Object.assign({}, this.store_instance);
        }
        return this.buffer;
      },
      set: function(v) {
        this.buffer = v;
      }
    },
    email: {
      get: function() {
        return this.instance.email || null;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.email = v;
      }
    },
    phone_number: {
      get: function() {
        return this.instance.phone_number || null;
      },
      set: function(v) {
        this.is_dirty = true;

        if (regex_phone.test(v)) {
          let start_digit = new RegExp(/^(\d)/i);
          if (start_digit.test(v)) {
            v = v.replace(/^(\d)/i, "+$1");
          }
        }
        v = v.replace(/[^\d\+]/g, "");

        this.instance.phone_number = v;
      }
    },
    first_name: {
      get: function() {
        return this.instance.first_name || null;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.first_name = v;
      }
    },
    last_name: {
      get: function() {
        return this.instance.last_name || null;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.last_name = v;
      }
    },
    email_visible: {
      get: function() {
        if (this.instance.email_visible === undefined) return false;
        return !!this.instance.email_visible;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.email_visible = !!v;
      }
    },
    phone_number_visible: {
      get: function() {
        if (this.instance.phone_number_visible === undefined) return false;
        return !!this.instance.phone_number_visible;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.phone_number_visible = !!v;
      }
    },
    last_name_visible: {
      get: function() {
        if (this.instance.last_name_visible === undefined) return false;
        return !!this.instance.last_name_visible;
      },
      set: function(v) {
        this.is_dirty = true;
        this.instance.last_name_visible = !!v;
      }
    },
    email_verified: {
      get: function() {
        return this.instance.email_verified || null;
      },
      set: function(v) {
        // this.instance.email_verified = v;
      }
    },
    phone_number_verified: {
      get: function() {
        return this.instance.phone_number_verified || null;
      },
      set: function(v) {
        // this.instance.phone_number_verified = v;
      }
    },
    provider: {
      get: function() {
        return this.instance.provider || null;
      },
      set: function(v) {
        // this.instance.provider = v;
      }
    },

    is_fullfilled: function() {
      return (
        this.email != null &&
        this.phone_number != null &&
        this.first_name != null
      );
    },

    can_save: function() {
      return this.is_dirty && this.form_valid;
    },

    rules: function() {
      return {
        phone_number: [
          // () => !this.email ? (!!this.phone_number || 'This field is required') : true,
          () =>
            this.phone_number
              ? regex_phone.test(this.phone_number) || "Invalid phone number"
              : true
        ],
        email: [
          // () => !this.phone_number ? (!!this.email || 'This field is required') : true,
          () =>
            this.email
              ? regex_email.test(this.email) || "Invalid email address"
              : true
        ],
        first_name: [
          // () => !!first_name || 'This field is required',
          () => true
        ]
      };
    },

    providers: function() {
      return _.get(this.firebase_user, "providerData", null);
    }
  },

  methods: {
    ...mapActions("user", {
      edit: "edit",
      update: "update"
    }),

    ...mapActions("errors", {
      unsetError: "unset"
    }),

    save: function() {
      this.update(this.buffer);
    },

    showSuccessMessage: function() {
      this.saved = true;
    },

    unsetErrors: function() {
      this.unsetError("email");
      this.unsetError("phone_number");
      this.unsetError("first_name");
      this.unsetError("last_name");
      this.unsetError("email_visible");
      this.unsetError("phone_number_visible");
      this.unsetError("last_name_visible");
    }
  },

  mounted: function() {
    this.edit();

    this.firebase_user = auth.getCurrentUser();
    // auth.onAuthStateChanged((user) => {
    // 	console.log(user);
    // 	this.firebase_user = user;
    // });

    this.$store.subscribe((mutation, state) => {
      if (mutation.type == "user/handleSaved") {
        this.is_dirty = false;
        this.showSuccessMessage();
      }
    });

    window.onbeforeunload = e => this.trans("app.confirm_leave_page");
  },

  beforeRouteLeave(to, from, next) {
    if (this.is_dirty == true) {
      const answer = window.confirm(this.trans("app.confirm_leave_page"));
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      next();
    }
  },

  beforeDestroy() {
    window.onbeforeunload = () => {};
    this.unsetErrors();
  }
};
</script>